module.exports = __webpack_public_path__ + "a4845096b523c3025c3a671050450902.svg";